import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flag, Award, Repeat, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function Home() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((res) => setProducts(res.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-16">
      {/* Hero — B2B / tournament messaging first. */}
      <section className="rounded-2xl bg-fairway-700 px-8 py-14 text-white">
        <p className="mb-3 inline-flex items-center gap-2 rounded-full bg-fairway-600 px-3 py-1 text-sm font-semibold">
          <Flag size={14} /> For Tournaments &amp; Events
        </p>
        <h1 className="max-w-2xl text-4xl font-extrabold leading-tight md:text-5xl">
          Give tournament players something they'll actually keep.
        </h1>
        <p className="mt-4 max-w-xl text-fairway-100">
          A custom-branded 3x5 first aid kit that clips onto a golf bag.
          Professional, practical promotional swag — add your logo and order in
          batches for your next event.
        </p>
        <div className="mt-6 flex gap-3">
          <Link to="/product/custom-logo-first-aid-kit" className="btn bg-white text-fairway-700 hover:bg-fairway-50">
            Customize Your Kit
          </Link>
          <Link to="/membership" className="btn-outline border-white text-white hover:bg-fairway-600">
            Refill Membership
          </Link>
        </div>
      </section>

      {/* Value props */}
      <section className="grid gap-6 md:grid-cols-3">
        {[
          { icon: Award, title: "Branded for your event", text: "Upload your logo and add the tournament name — we print it on every kit." },
          { icon: CheckCircle2, title: "Actually useful swag", text: "Bandages, wipes, blister pads and more — recipients keep it, not toss it." },
          { icon: Repeat, title: "Optional refill membership", text: "Recipients can stay stocked year-round for just $14/year." },
        ].map(({ icon: Icon, title, text }) => (
          <div key={title} className="card p-6">
            <Icon className="mb-3 text-fairway-600" size={28} />
            <h3 className="font-bold">{title}</h3>
            <p className="mt-1 text-sm text-gray-600">{text}</p>
          </div>
        ))}
      </section>

      {/* Catalog */}
      <section>
        <h2 className="mb-5 text-2xl font-extrabold">Our Kits</h2>
        <div className="grid gap-6 md:grid-cols-2">
          {products.map((p) => (
            <Link
              key={p.id}
              to={`/product/${p.slug}`}
              className="card flex flex-col p-6 transition hover:shadow-md"
            >
              {p.badge && (
                <span className="mb-2 w-fit rounded-full bg-fairway-100 px-2.5 py-0.5 text-xs font-semibold text-fairway-700">
                  {p.badge}
                </span>
              )}
              <h3 className="text-lg font-bold">{p.name}</h3>
              <p className="mt-1 flex-1 text-sm text-gray-600">{p.tagline}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xl font-extrabold text-fairway-700">
                  ${p.price?.toFixed(2)}
                </span>
                <span className="text-sm font-semibold text-fairway-600">
                  Customize →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
